import { render } from "./ConfigTitle.vue?vue&type=template&id=21e5897e"
import script from "./ConfigTitle.vue?vue&type=script&lang=js"
export * from "./ConfigTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/widget/configs/ConfigTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21e5897e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21e5897e', __exports__)) {
    api.reload('21e5897e', __exports__)
  }
  
  module.hot.accept("./ConfigTitle.vue?vue&type=template&id=21e5897e", () => {
    api.rerender('21e5897e', render)
  })

}


export default __exports__